export const RevokeIconSVG = ({heightWidth = 26}: any) => (
  <svg
    width={heightWidth}
    height={heightWidth}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.2194 23.9019C19.9544 26.1669 16.9784 27.3 14.0032 27.3C11.0273 27.3 8.05191 26.1675 5.78637 23.9019C3.27624 21.3918 2.06208 17.9269 2.45529 14.395C2.52618 13.7573 3.10717 13.2932 3.73871 13.3692C4.37641 13.4401 4.83598 14.0143 4.76452 14.6526C4.4502 17.4781 5.42151 20.251 7.42955 22.2589C11.0534 25.8828 16.9512 25.8838 20.5763 22.2589C24.2007 18.6339 24.2007 12.7366 20.5763 9.11212C17.5102 6.04656 12.7595 5.56491 9.16916 7.75329L12.9596 8.72184C13.5256 8.86646 13.9365 9.39493 13.875 9.97584C13.8093 10.5952 13.2923 11.0214 12.7192 11.0214C12.6245 11.022 12.5274 11.01 12.431 10.985L5.97711 9.33592C5.40271 9.18915 5.05605 8.60454 5.20281 8.03014L6.85192 1.57568C7.01018 0.954244 7.64115 0.575203 8.26525 0.737533C8.88715 0.896377 9.26212 1.52908 9.10328 2.15086L8.2204 5.60616C12.6777 3.05292 18.4622 3.71165 22.2194 7.46883C26.7499 11.9989 26.7499 19.3708 22.2194 23.9019Z"
      fill="url(#paint0_linear_1515_4620)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1515_4620"
        x1="-0.852139"
        y1="-0.593929"
        x2="24.9126"
        y2="27.6413"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1" stopColor="#1075FF" />
      </linearGradient>
    </defs>
  </svg>
);
